module.exports = __webpack_public_path__ + "media/custom/images/img37-3261faaf6d61fb29219e49cbb4d422d6.jpg";